import React, { useState } from "react";
import "./contact.css";
import "../../assets/css/bootstrap.min.css";
import planeImage from "../../assets/images/plane.png";
import tempo from "../../assets/images/the-mystery-machine-van-CT0X2Y-removebg-preview.png";
import Swal from "sweetalert2"; // Import SweetAlert2
import "sweetalert2/dist/sweetalert2.min.css";


const Contact = () => {
  const [numKids, setNumKids] = useState(0);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    numPersons: "",
    numKids: "",
    kidsAges: "",
    tourType: "domestic",
    callDateTime: "",
    startDate: "",
    endDate: "",
    vacationType: "group",
    vacationDays: "weekend",
    roomPreference: "3stars",
    message: ""
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };
 

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validation for mandatory fields
    if (!formData.firstName.trim() || !formData.lastName.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please enter your first name and last name.",
      });
      return;
    }
  
    if (!formData.phone.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Phone number is required.",
      });
      return;
    }
  
    if (!formData.email.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Email address is required.",
      });
      return;
    }
  
    if (!formData.numPersons.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please specify the number of persons.",
      });
      return;
    }
  
    if (!formData.callDateTime.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Preferred call date and time are required.",
      });
      return;
    }
  
    if (!formData.startDate.trim() || !formData.endDate.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Start and end dates for the tour are required.",
      });
      return;
    }
  
    // Map user input to Web3Forms expected format
    const dataToSend = {
      access_key: "1a396b5c-5401-40f9-bdec-076315d8e1a6", // Replace with your Web3Forms Access Key
      name: `${formData.firstName} ${formData.lastName}`, // Combine first name and last name
      email: formData.email,
      message: formData.message || "No additional message provided.",
      phone: formData.phone,
      numPersons: formData.numPersons,
      numKids: formData.numKids,
      kidsAges: formData.kidsAges,
      tourType: formData.tourType,
      callDateTime: formData.callDateTime,
      startDate: formData.startDate,
      endDate: formData.endDate,
      vacationType: formData.vacationType,
      vacationDays: formData.vacationDays,
      roomPreference: formData.roomPreference,
    };
  
    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Server Error:", errorData);
  
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errorData.message || "Something went wrong while submitting the form!",
        });
      } else {
        const data = await response.json();
        console.log("Success:", data);
  
        Swal.fire({
          icon: "success",
          title: "Thank You!",
          text: "Your form has been successfully submitted.",
          confirmButtonText: "OK",
        });
  
        // Reset the form data after successful submission
        setFormData({
          firstName: "",
          lastName: "",
          phone: "",
          email: "",
          numPersons: "",
          numKids: "",
          kidsAges: "",
          tourType: "domestic",
          callDateTime: "",
          startDate: "",
          endDate: "",
          vacationType: "group",
          vacationDays: "weekend",
          roomPreference: "3stars",
          message: "",
        });
  
        setResult("Thank you! Your form has been successfully submitted.");
      }
    } catch (error) {
      // console.error("Network Error:", error);
  
      Swal.fire({
        icon: "success",
        title: "Thank You!",
        text: "Your form has been successfully submitted.",
        confirmButtonText: "OK",
      });
    }
  };
  


  return (
    <section
      className="uf-contact-form-01 mx-auto"
      style={{ maxWidth: "fit-content", overflow: "hidden" }}
    >
      <div className="container">
        <div
          className="row justify-content-center rounded-4 shadow py-5 gx-5 px-lg-5 overflow-hidden mt-4"
          style={{
            backgroundColor: "#d9a52ab3 ",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="col-md-6 text-center">
            <h1 className="text-uppercase fw-bold" style={{ color: "#d9a52a !important" }}>
              Contact Us
            </h1>
            <p style={{ fontSize: "30px" }}>
              Contact us for inquiries or bookings
            </p>
            <p>
              Or reach out manually to{" "}
              <a href="mailto:bookings@aroundtheglobe.co.in" className="text-decoration-none" style={{ fontSize: "20px" }}>
                bookings@aroundtheglobe.co.in
              </a>
            </p>
            <p style={{ fontSize: "20px" }}>+91 84879 00695</p>
            <img
              src={planeImage}
              alt="Contact Plane"
              className="uf-img-contact-form-01 pt-4 d-md-block d-none plane-animation"
            />
            <img
              src={tempo}
              alt="Contact Tempo"
              style={{ width: "100%" }}
              className="pt-4 d-md-block d-none"
            />
          </div>

          <div className="col-md-6 form-container">
            <form onSubmit={handleSubmit}>
              {/* Name Fields */}
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  placeholder="Your first name"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  placeholder="Your last name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>

              {/* Contact Details */}
              <div className="mb-3">
                <input
                  type="tel"
                  className="form-control"
                  id="phone"
                  placeholder="Phone Number*"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>

              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Your email*"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              {/* Number of Persons */}
              <div className="mb-3">
                <input
                  type="number"
                  className="form-control"
                  id="numPersons"
                  placeholder="Number of Persons*"
                  min="1"
                  value={formData.numPersons}
                  onChange={handleInputChange}
                />
              </div>

              {/* Number of Kids */}
              <div className="mb-3">
                <input
                  type="number"
                  className="form-control"
                  id="numKids"
                  placeholder="Number of Kids (if any)"
                  min="0"
                  value={formData.numKids}
                  onChange={(e) => {
                    setNumKids(parseInt(e.target.value, 10));
                    handleInputChange(e);
                  }}
                />
              </div>

              {/* Ages of Kids (Only Show When Kids Exist) */}
              {numKids > 0 && (
                <div className="mb-3">
                  <label htmlFor="kidsAges" className="form-label">
                    Ages of Kids (separate with commas)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="kidsAges"
                    placeholder="e.g., 5, 7, 10"
                    value={formData.kidsAges}
                    onChange={handleInputChange}
                  />
                </div>
              )}

              {/* Tour Type */}
              <div className="mb-3">
                <select
                  className="form-select"
                  id="tourType"
                  value={formData.tourType}
                  onChange={handleInputChange}
                >
                  <option value="domestic">Domestic</option>
                  <option value="international">International</option>
                </select>
              </div>

              {/* Preferred Date and Time to Call */}
              <div className="mb-3">
                <label htmlFor="callDateTime" className="form-label">
                  Preferred Date and Time to Call*
                </label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="callDateTime"
                  value={formData.callDateTime}
                  onChange={handleInputChange}
                />
              </div>

              {/* Tour Start and End Dates */}
              <div className="mb-3">
                <label htmlFor="tourDates" className="form-label">
                  Tour Start and End Dates*
                </label>
                <div className="d-flex gap-3">
                  <input
                    type="date"
                    className="form-control"
                    id="startDate"
                    placeholder="Start Date"
                    value={formData.startDate}
                    onChange={handleInputChange}
                  />
                  <input
                    type="date"
                    className="form-control"
                    id="endDate"
                    placeholder="End Date"
                    value={formData.endDate}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Vacation Type */}
              <div className="mb-3">
                <select
                  className="form-select"
                  id="vacationType"
                  value={formData.vacationType}
                  onChange={handleInputChange}
                >
                  <option value="group">Group/Friends Vacation</option>
                  <option value="couple">Couple Vacation</option>
                  <option value="family">Family Vacation</option>
                </select>
              </div>

              {/* Vacation Days */}
              <div className="mb-3">
                <select
                  className="form-select"
                  id="vacationDays"
                  value={formData.vacationDays}
                  onChange={handleInputChange}
                >
                  <option value="weekend">Weekend Vacation</option>
                  <option value="4nights">4 Nights 5 Days</option>
                  <option value="moreThanWeek">More than A Week!</option>
                </select>
              </div>

              {/* Room Preference */}
              <div className="mb-3">
                <select
                  className="form-select"
                  id="roomPreference"
                  value={formData.roomPreference}
                  onChange={handleInputChange}
                >
                  <option value="3stars">3 Stars</option>
                  <option value="4stars">4 Stars</option>
                  <option value="5stars">5 Stars</option>
                  <option value="7stars">7 Stars</option>
                </select>
              </div>

              {/* Message */}
              <div className="mb-3">
                <textarea
                  className="form-control"
                  id="message"
                  rows="3"
                  placeholder="Your message"
                  value={formData.message}
                  onChange={handleInputChange}
                ></textarea>
              </div>

              <button type="submit" className="button-3d">
                Send Message
              </button>
              {/* <a className="box__link button-animation"  type="submit"  >
Send Message
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </a> */}
              
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
